module.exports = __webpack_public_path__ + "img/close.be387df8.svg";